import React, { Component, useState } from 'react';
import { connect } from 'react-redux';
import { randomToken, smsToken } from '../../Actions/login'
import Select from 'react-select';
import { toast } from 'react-toastify';
import { browserHistory } from 'react-router';
import styled from 'styled-components';
import { Popup } from '../Popup/index';


const renderBackdrop = (props) => <div className="backdrop" {...props} />;
class Promotional extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cliente: {},
      clientes: [],
      open: false,
      estados: [],
      estadoSelected: null,
      popupOpen: false,
      userValidatedPhone: false,
    }
  }

  async componentDidMount() {

    if (this.props.login.token === null) {
      browserHistory.push("/login");

    }

    if (this.props.login.isFirstAccess) {

      await this.getEstados();

      this.refs.confSenhaCliente.value = "";
      this.refs.senhaCliente.value = "";
    } else {

      this.refs.confSenhaCliente.value = this.props.login.user.SENHA;
      this.refs.senhaCliente.value = this.props.login.user.SENHA;

    }

    let maskedName
    if (this.props.login.user.NOMCLI && this.props.login.user.NOMCLI !== "") {
      let firstName = this.props.login.user.NOMCLI.slice(0, this.props.login.user.NOMCLI.indexOf(" "));
      console.log(this.props.login.user.NOMCLI)
      let lastName = this.props.login.user.NOMCLI.slice(this.props.login.user.NOMCLI.indexOf(" "), this.props.login.user.NOMCLI.length);
      let splitLastName = lastName.split(" ");
      let split = " ";
      for (let i = 0; i < splitLastName.length; i++) {
        split += new Array(splitLastName[i].length + 1).join("*") + " ";
      }
      maskedName = firstName + split;
    }
    this.refs.nomeCliente.value = maskedName
    // this.refs.dddCliente.value = this.props.login.user.DDD;

    // let number;
    // if (this.props.login.user.FONE && this.props.login.user.FONE.length == 8) {
    //   number = 9 + String(this.props.login.user.FONE);

    // } else {
    //   number = String(this.props.login.user.FONE);
    // }
    // const maskedfone = "*****" + number.substring(5, 9);
    // this.refs.telefoneCliente.value = maskedfone;

    // const email = this.props.login.user.EMAIL
    // if (email && email !== "") {
    //   let splitEmail = email.split("@", 2)
    //   const maskedemail = email.substring(0, 3) + "*****" + "@" + splitEmail[1];
    //   this.refs.emailCliente.value = maskedemail;
    // }
    this.setState({ estadoSelected: { value: this.props.login.user.ESTADO, label: this.getLabelEstado(this.props.login.user.ESTADO) } });

  }

  getLabelEstado = estado => {
    switch (estado) {
      case 'MG':
        return 'Minas Gerais'
      case 'AC':
        return 'Acre'
      case 'AL':
        return 'Alagoas'
      case 'AP':
        return 'Amapa'
      case 'AM':
        return 'Amazonas'
      case 'BA':
        return 'Bahia'
      case 'CE':
        return 'Ceara'
      case 'DF':
        return 'Distrito Federal'
      case 'ES':
        return 'Espirito Santo'
      case 'GO':
        return 'Goias'
      case 'MA':
        return 'Maranhao'
      case 'MT':
        return 'Mato Grosso'
      case 'MS':
        return 'Mato Grosso Do Sul'
      case 'PA':
        return 'Para'
      case 'PB':
        return 'Paraiba'
      case 'PR':
        return 'Parana'
      case 'PE':
        return 'Pernambuco'
      case 'PI':
        return 'Piaui'
      case 'RJ':
        return 'Rio De Janeiro'
      case 'RN':
        return 'Rio Grande Do Norte'
      case 'RS':
        return 'Rio Grande Do Sul'
      case 'RO':
        return 'Rondonia'
      case 'RR':
        return 'Roraima'
      case 'SC':
        return 'Santa Catarina'
      case 'SP':
        return 'Sao Paulo'
      case 'SE':
        return 'Sergipe'
      case 'TO':
        return 'Tocantins'
      default:
        return ''
    }
  }


  handleOpenModal = () => {
    this.setState({ popupOpen: true })
  }

  handleAutenticated = () => {
    this.setState({ userValidatedPhone: true })
    this.closeModal()
  }

  closeModal = async () => {
    this.setState({ popupOpen: false });
  };

  showPopup() {

    const GroupPopup = styled.div`
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-items: center;
      justify-content: space-around;
      width: 100%;
      padding: 0px 10px 8px 10px;
    `;

    const TitlePopup = styled.p`
      text-align: center;
      color: #01579b;
      font-weight: bold;
      font-family: "Open Sans", sans-serif;
      font-size: 20px;

      span {
        color: #01579b;
        font-weight: bold;
      }
    `;

    const ContentPopup = styled.div`
      text-align: center;
      justify-items: center;
      font-family: "Open Sans", sans-serif;
      font-size: 26px;

      color: #ffff;
      display: flex;
      align-items: center;
      border-radius: 4px;
      padding: 3px 10px 3px 10px;
      background-color: #01579b;
      box-shadow: 2px 4px 0px 1.5px rgb(7, 44, 72);

      svg {
        color: #ffff;
        size: 24;
        margin-left: 14px;
        cursor: pointer;

          &:hover {
            color: #ffd502;
          }
        }
      `;

    const ButtonPopup = styled.button`
      background-color: #34a734;
      border: none;
      color: white;
      height: 60;
      width: 200px;
      cursor: pointer;
      font-size: 15px;
      margin-top: 10px;
    `;

    const InputPopup = styled.input`
      border-style: groove;
      height: 40;
      display: flex;
      font-size: 15px;
      border-radius: 5px;
      outline-style: none;

      ::placeholder {
        color: #dcdcdc;
      }
    `;

    return (

      <Popup close={this.closeModal} userValidated={this.handleAutenticated} tokenAuthApi={this.props.login.token} />
    )
  }

  submitClient = async e => {
    e.preventDefault();
    console.log(this.refs.senhaCliente.value);
    if (this.refs.confSenhaCliente.value !== this.refs.senhaCliente.value) {

      toast.error('Senhas não conferem!');
    } else {
      const cli = {
        CODCLI: this.props.login.user.CODCLI,
        CGCCPF: this.props.login.user.CGCCPF,
        CODEND: this.props.login.user.CODEND,
        NOMCLI: this.props.login.user.NOMCLI,
        DTNASC: this.props.login.user.DTNASC,
        CEP: this.props.login.user.CEP,
        CODLOGRAD: this.props.login.user.CODLOGRAD,
        TPENDER: this.props.login.user.TPENDER,
        ENDERECO: this.props.login.user.ENDERECO,
        NUMERO: this.props.login.user.NUMERO,
        COMPLEMENTO: this.props.login.user.COMPLEMENTO,
        BAIRRO: this.props.login.user.BAIRRO,
        CIDADE: this.props.login.user.CIDADE,
        ESTADO: this.props.login.user.ESTADO,
        SEXO: this.props.login.user.SEXO,
        DDD: this.props.login.user.DDD,
        FONE: this.props.login.user.FONE,
        EMAIL: this.props.login.user.EMAIL,
        SENHA: this.refs.senhaCliente.value
      }
      console.log(cli);
      const URL = `${process.env.REACT_APP_API_URL}/api/boletopwa/clientzema`;
      const HEADER = new Headers({
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.props.login.token}`
      });

      await fetch(URL, { method: "POST", headers: HEADER, body: JSON.stringify(cli) })
        .then(response => response.json())
        .then(cli => {
          toast.success(`Dados confirmados`);
          browserHistory.push("/venda");
        })
        .catch(err => {
          console.log('err', err);
        });

      localStorage.setItem(`boleto@cart${this.props.login.user.CGCCPF}`, JSON.stringify(this.props.cart));
    }
  }


  getEstados = async () => {
    const URL = `${process.env.REACT_APP_API_URL}/api/adresses/estados`;
    const HEADER = new Headers({
      Accept: "application/json",
      Authorization: `Bearer ${this.props.login.token}`
    });

    await fetch(URL, { method: "GET", headers: HEADER })
      .then(response => response.json())
      .then(esta => {
        if (esta.length > 0) {
          let estados = [];
          for (let i = 0; i < esta.length; i++) {
            const estado = {
              value: esta[i].UF,
              label: esta[i].DESCRICAO
            }
            estados.push(estado);
          }

          this.setState({ estados });
        }
        else
          toast.error('Problemas ao buscar os Estados. Tente novamente.');
      })
      .catch(err => {
        toast.error(err);
      })
  }

  handleEstadoChange = (estadoSelected) => {
    this.setState({ estadoSelected });
  }


  render() {
    return (

      <div className="cartClient">

        <div className="newclient container-fluid">

          <h3>Dados Cadastrais</h3>
          <small id="emailHelp2" className="form-text text-muted">Atualize e confirme seus dados.</small>
          <div className="row">
            <div className="col-sm-12 col-md-9 col-lg-8">
              <div className="inputField">
                <div className="inputField__icon">
                  <i className="fa fa-user"></i>
                </div>
                <input type="text" disabled placeholder="Nome" ref="nomeCliente" maxLength="40" />
              </div>
            </div>

          </div>

          <form method='POST' onSubmit={this.submitClient}>
            <div className="row" style={this.props.login.isFirstAccess ? null : { display: 'none' }}>
              <div className="col-sm-12 col-md-8 col-lg-6">
                <div className="inputField">
                  <div className="inputField__icon">
                    <i className="fa fa-asterisk"></i>
                  </div>
                  <input type="password" placeholder="Senha" ref="senhaCliente" text="" required />
                </div>
                <small id="emailHelp" className="form-text text-muted">*A senha será solicitada nos próximos acessos.</small>
              </div>

              <div className="col-sm-12 col-md-8 col-lg-6">
                <div className="inputField">
                  <div className="inputField__icon">
                    <i className="fa fa-asterisk"></i>
                  </div>
                  <input type="password" placeholder="Confirmar Senha" ref="confSenhaCliente" required />
                </div>

              </div>

            </div>
            <div className='_btn'>
              <div className="row">
                <div className="col-sm-12">
                  <button
                    type="submit"
                    className="_btn _btn--success"
                    disabled={!this.state.userValidatedPhone}
                  >

                    Confirmar Dados e Continuar
                  </button>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <button
                    type='button'
                    onClick={this.handleOpenModal}
                    className="_btn _btn--validation"
                    disabled={this.state.userValidatedPhone}
                  >
                    Valide seu telefone
                  </button>
                </div>
              </div>
              {this.state.popupOpen && this.showPopup()}
            </div>
          </form>
        </div>
      </div>

    );
  }
}

const mapStateToProps = state => ({ login: state.login });
export default connect(mapStateToProps)(Promotional);



// WEBPACK FOOTER //
// ./src/Components/Home/Promotional.js